/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterCareerAddPost } from '../fn/career/api-master-career-add-post';
import { ApiMasterCareerAddPost$Params } from '../fn/career/api-master-career-add-post';
import { apiMasterCareerDeleteGet } from '../fn/career/api-master-career-delete-get';
import { ApiMasterCareerDeleteGet$Params } from '../fn/career/api-master-career-delete-get';
import { apiMasterCareerEditPost } from '../fn/career/api-master-career-edit-post';
import { ApiMasterCareerEditPost$Params } from '../fn/career/api-master-career-edit-post';
import { apiMasterCareerGetActiveGet } from '../fn/career/api-master-career-get-active-get';
import { ApiMasterCareerGetActiveGet$Params } from '../fn/career/api-master-career-get-active-get';
import { apiMasterCareerGetAllGet } from '../fn/career/api-master-career-get-all-get';
import { ApiMasterCareerGetAllGet$Params } from '../fn/career/api-master-career-get-all-get';
import { apiMasterCareerGetByCriteriaPost } from '../fn/career/api-master-career-get-by-criteria-post';
import { ApiMasterCareerGetByCriteriaPost$Params } from '../fn/career/api-master-career-get-by-criteria-post';
import { apiMasterCareerGetByIdGet } from '../fn/career/api-master-career-get-by-id-get';
import { ApiMasterCareerGetByIdGet$Params } from '../fn/career/api-master-career-get-by-id-get';
import { Career } from '../models/career';
import { CareerApiRespModel } from '../models/career-api-resp-model';
import { StringApiRespModel } from '../models/string-api-resp-model';

@Injectable({ providedIn: 'root' })
export class CareerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterCareerAddPost()` */
  static readonly ApiMasterCareerAddPostPath = '/api/Master/Career/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCareerAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCareerAddPost$Response(params?: ApiMasterCareerAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CareerApiRespModel>> {
    return apiMasterCareerAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCareerAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCareerAddPost(params?: ApiMasterCareerAddPost$Params, context?: HttpContext): Observable<CareerApiRespModel> {
    return this.apiMasterCareerAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CareerApiRespModel>): CareerApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCareerEditPost()` */
  static readonly ApiMasterCareerEditPostPath = '/api/Master/Career/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCareerEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCareerEditPost$Response(params?: ApiMasterCareerEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CareerApiRespModel>> {
    return apiMasterCareerEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCareerEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCareerEditPost(params?: ApiMasterCareerEditPost$Params, context?: HttpContext): Observable<CareerApiRespModel> {
    return this.apiMasterCareerEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CareerApiRespModel>): CareerApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCareerDeleteGet()` */
  static readonly ApiMasterCareerDeleteGetPath = '/api/Master/Career/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCareerDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCareerDeleteGet$Response(params?: ApiMasterCareerDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterCareerDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCareerDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCareerDeleteGet(params?: ApiMasterCareerDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterCareerDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCareerGetAllGet()` */
  static readonly ApiMasterCareerGetAllGetPath = '/api/Master/Career/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCareerGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCareerGetAllGet$Response(params?: ApiMasterCareerGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Career>>> {
    return apiMasterCareerGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCareerGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCareerGetAllGet(params?: ApiMasterCareerGetAllGet$Params, context?: HttpContext): Observable<Array<Career>> {
    return this.apiMasterCareerGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Career>>): Array<Career> => r.body)
    );
  }

  /** Path part for operation `apiMasterCareerGetActiveGet()` */
  static readonly ApiMasterCareerGetActiveGetPath = '/api/Master/Career/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCareerGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCareerGetActiveGet$Response(params?: ApiMasterCareerGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Career>>> {
    return apiMasterCareerGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCareerGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCareerGetActiveGet(params?: ApiMasterCareerGetActiveGet$Params, context?: HttpContext): Observable<Array<Career>> {
    return this.apiMasterCareerGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Career>>): Array<Career> => r.body)
    );
  }

  /** Path part for operation `apiMasterCareerGetByIdGet()` */
  static readonly ApiMasterCareerGetByIdGetPath = '/api/Master/Career/GetById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCareerGetByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCareerGetByIdGet$Response(params?: ApiMasterCareerGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Career>> {
    return apiMasterCareerGetByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCareerGetByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCareerGetByIdGet(params?: ApiMasterCareerGetByIdGet$Params, context?: HttpContext): Observable<Career> {
    return this.apiMasterCareerGetByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Career>): Career => r.body)
    );
  }

  /** Path part for operation `apiMasterCareerGetByCriteriaPost()` */
  static readonly ApiMasterCareerGetByCriteriaPostPath = '/api/Master/Career/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCareerGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCareerGetByCriteriaPost$Response(params?: ApiMasterCareerGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Career>>> {
    return apiMasterCareerGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCareerGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCareerGetByCriteriaPost(params?: ApiMasterCareerGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<Career>> {
    return this.apiMasterCareerGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Career>>): Array<Career> => r.body)
    );
  }

}
